'use es6';

import Hubs from 'self-service-api/constants/Hubs';
import { CMS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
export const MAX_VISIBLE_PURCHASE_MOTIONS_PA = productLine => [CMS, SALES, SERVICE].includes(productLine) ? 3 : 2;
export const MAX_VISIBLE_PURCHASE_MOTIONS = hub => [Hubs.HUB_CMS, Hubs.HUB_SALES, Hubs.HUB_SERVICE].includes(hub) ? 3 : 2;